import PropTypes from "prop-types";

const InputFieldErrors = ({ errors, fieldName }) => {
  const fieldErrors = errors?.[fieldName];

  if (!fieldErrors?.length) {
    return null;
  }

  return (
    <div style={{ color: "red" }}>
      <ul style={{ paddingLeft: "1rem", margin: 0 }}>
        {fieldErrors.map((fieldError, index) => (
          <li key={index}>{fieldError}</li>
        ))}
      </ul>
    </div>
  );
};

InputFieldErrors.propTypes = {
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  fieldName: PropTypes.string.isRequired
};

export default InputFieldErrors;
